import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortlists';
import { CSVLink } from 'react-csv';


class UpdateLyricist extends Component {

    constructor(props) {
        super(props);
        this.state = {
            codes: "",
            isrcs: "",
            selectedOption: null,
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();  
   
}

componentDidUpdate() {
    // This method is called when the route parameters change
    //this.ensureDataFetched();
    console.info("test")
    if (this.props.updateUPCSLyricist.length > 0 && !this.props.isUpdatingProductLyricist) {
       
        this.props.updateLyricistFromComposerByUpc(this.props.updateUPCSLyricist[0]);
    }
   
   
    }

   

ensureDataFetched() {
   
    // this.props.requestWeatherForecasts(startDateIndex);
   // this.props.getData();
 
    }


    onUPCChange(e) {
        this.setState({ codes: e.target.value });
    }

    onISRCChange(e) {
        this.setState({ isrcs: e.target.value });
    } 

    selectListType(data) {

        this.setState(
            { selectedOption : data });

    }

    setPublishUpdate(e, selection) {
        var array = e.split(" ");       
        this.props.setUpdateUPCsLyricist(array,selection);
    }


render() {
     
    return (
        <div>              
                <h1>Update Lyricist from Composer by Products</h1>

            <p>{this.props.updateUPCSLyricist.length} products left to update </p>
            <p>{this.props.updateUPCSLyricist.length > 0 ? "Updating from Fuga " + this.props.requestedUpdateUPCLyricist : ""}</p>
            <p>{this.props.updateUPCSLyricist.length > 0 ? "(please don't reload or close the tab)" : ""}</p>
          
                <div className="row">
                <div className="col-sm-6">
                    <input type="text" disabled={this.props.isUpdatingProductLyricist || this.props.updateUPCSLyricist.length > 0} className="form-control" id="shortlistISRC" placeholder={"UPCS to Update from Fuga"} onChange={(e) => this.onUPCChange(e)} value={this.state.codes} ></input>
                </div>
               
                <div className="col-sm-3">
                    <button disabled={this.state.codes === '' || this.props.isUpdatingProductLyricist || this.props.updateUPCSLyricist.length > 0} onClick={(e) => this.setPublishUpdate(this.state.codes)}>Update</button></div>
            </div>
            <br />
            <br/>
                <div className="row">
                <div className="col-sm-12">
                    {this.props.updateResultsLyricist !== null && this.props.updateResultsLyricist.length > 0 ? <CSVLink separator=";" data={this.props.updateResultsLyricist} filename={"publish-List-Data.csv"} >Download CSV</CSVLink> : ""}
                    {this.props.updateResultsLyricist.length > 0 ? renderReactTable(this.props.updateResultsLyricist, this.props, this) : ""}
                    </div>
                </div>

            </div>
          
     
            
            
          

        
    );
}
}



function renderReactTable(data, props,main) {

    
    const getColumns = () => {
        return Object.keys(data[0]).map(key => {
            return {
                Header: key,
                accessor: key
            };
        });
    }
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {
              
                style: {
                    background: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',
                    
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}
          
            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;                
                if (typeof filter.value === "object") {                    
                    return row[id] !== undefined || row[id] !==  null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}

              
            columns={getColumns()}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};





export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(UpdateLyricist);



// WEBPACK FOOTER //
// ./src/components/UpdateLyricist.js